<ng-select
  [attr.id]="inputId || null"
  class="form-control"
  [items]="items"
  [searchable]="searchable"
  [clearable]="clearable"
  [virtualScroll]="virtualScroll"
  [loading]="loading"
  [notFoundText]="notFoundText"
  [loadingText]="loadingText"
  [ngModel]="value"
  [disabled]="isDisabled"
  (ngModelChange)="onValueChange($event)"
  (blur)="onTouched()"
  [attr.aria-label]="ariaLabel"
>
</ng-select>
